@if (isValidEnv()) {
  <mat-chip id="environement"
            aria-label="Enviroment: {{ env }}"
            [ngClass]="[getEnvChipBaseClass(), getEnvClass()]"
            [attr.data-tfa]="'environement-' + env">
    {{ displayEnv }}
  </mat-chip>
}
